import { LocalDate } from '@js-joda/core';

import { ButtonVariant, ModalConfirmButton } from '@dreryk/react-components';

import { invoiceCreateModalTranslationKeys } from '../../translations';
import { InvoiceCreateFormController } from '../form/InvoiceCreateForm.types';
import { usePrivateIndividualInvoiceCreateCommand } from '../PrivateIndividualInvoiceCreateModalConfirmButton.hooks';
import { InvoicePaymentMethod } from '../../types';

type ContinueWithoutReceiptModalConfirmButtonProps = Pick<InvoiceCreateFormController, 'handleSubmit'> & {
   readonly onSuccess: VoidFunction;
   readonly paymentMethod: InvoicePaymentMethod;
   readonly visitDate: LocalDate;
   readonly visitSettlementId: number;
};

export const ContinueWithoutReceiptModalConfirmButton = (
   props: ContinueWithoutReceiptModalConfirmButtonProps
): JSX.Element => {
   const { onSuccess, handleSubmit, paymentMethod, visitDate, visitSettlementId } = props;

   const { executeAsync: createPrivateIndividualInvoice } = usePrivateIndividualInvoiceCreateCommand({
      onSuccess: onSuccess,
      paymentMethod: paymentMethod,
      visitDate: visitDate,
      visitSettlementId: visitSettlementId,
      receiptAvailableForInvoice: false,
   });

   return (
      <ModalConfirmButton
         testId={'continueWithoutReceipt'}
         label={invoiceCreateModalTranslationKeys.withReceipt.continueWithoutReceipt}
         onClick={handleSubmit(createPrivateIndividualInvoice)}
         variant={ButtonVariant.SECONDARY}
      />
   );
};
